import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/projects', 'get'>;
type ResponseBody = OASOutput<O, '/api/projects', 'get'>;

type Params = {
  cursor?: string;
  nameFilter?: string;
  tagNamesFilter?: string[];
  pageSize?: number;
  orderBy?: 'Oldest' | 'Newest' | 'Alphabetical' | 'ReverseAlphabetical' | 'RecentlyModified' | 'LeastRecentlyModified';
};

type ProjectTile = {
  id: number;
  guid: string;
  name: string;
  thumbnailUrl: string;
  tagGuids: string[];
};

type Result = {
  totalCount: number;
  nextPageCursor: string | null;
  records: ProjectTile[];
};

export const listProjectsFactory = (apiClient: ApiClient) => {
  const listProjects = async (variables?: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/projects'].get(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input?: Params): RequestParams => {
    if (!input) {
      return {
        query: {
          PageSize: 12,
        },
      };
    }

    return {
      query: {
        Cursor: input.cursor,
        NameFilter: input.nameFilter,
        TagNamesFilter: input.tagNamesFilter,
        PageSize: input.pageSize ?? 12,
        OrderBy: input.orderBy,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      totalCount: response.totalCount,
      nextPageCursor: response.nextPageCursor ?? null,
      records: response.records.map((record) => ({
        id: record.id,
        guid: record.guid,
        name: record.name,
        thumbnailUrl: record.thumbnailUrl,
        tagGuids: record.tagGuids,
      })),
    };
  };

  return listProjects;
};
